import {
  loginUser as loginUserAPI,
  registerUser as registerUserAPI,
  connectZoomAccount as connectZoomAccountAPI,
  connectHubspotAccount as connectHubspotAccountAPI,
  getUser as getUserAPI,
} from '../api/users';

import { getUserId } from '../helpers/user_helpers';
import { removeUrlParameter } from '../helpers/formatting';
import { intitializeAmplitude } from '../api/events';
import { intitializeIntercom } from '../helpers/chat_helpers';

export const SAVE_REAL_USER_PROFILE = 'SAVE_REAL_USER_PROFILE';
export const CLEAR_REAL_USER_PROFILE = 'CLEAR_REAL_USER_PROFILE';
export const SYNC_USER_SUCCESS = 'SYNC_USER_SUCCESS';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILURE = 'REGISTER_USER_FAILURE';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const CONNECT_ZOOM_ACCOUNT_SUCCESS = 'CONNECT_ZOOM_ACCOUNT_SUCCESS';
export const CONNECT_ZOOM_ACCOUNT_FAILURE = 'CONNECT_ZOOM_ACCOUNT_FAILURE';
export const CONNECT_HUBSPOT_ACCOUNT_SUCCESS = 'CONNECT_HUBSPOT_ACCOUNT_SUCCESS';
export const CONNECT_HUBSPOT_ACCOUNT_FAILURE = 'CONNECT_HUBSPOT_ACCOUNT_FAILURE';

export const mockUser = (mockUser) => async (dispatch, getState) => {
  const isClearingMockUser = !mockUser;
  const mockUserId = isClearingMockUser ? getUserId(getState().user?.realProfile) : mockUser.id;

  // Grab the initial user
  const adminUser = getState().user?.realProfile || getState().user?.profile; // Always save the initial profile

  // Reset to the base user
  dispatch({ type: CLEAR_REAL_USER_PROFILE });

  // Get the new user object
  const user = await getUserAPI(mockUserId);

  // Store user profile object for fixing later
  !isClearingMockUser && dispatch({ type: SAVE_REAL_USER_PROFILE, user: adminUser });

  // Reload the page to ensure a reset of behavior
  setTimeout(() => window.location.reload(), 250);

  return dispatch({
    type: SYNC_USER_SUCCESS,
    user,
    skipLogging: true,
  });
};
export const syncUser = () => async (dispatch, getState) => {
  const id = getUserId(getState().user);
  const user = await getUserAPI(id);

  intitializeIntercom(user);
  intitializeAmplitude(user);
  return dispatch({
    type: SYNC_USER_SUCCESS,
    user,
  });
};

export const loginUser = ({ email, password }) => async (dispatch, getState) => {
  try {
    const userResp = await loginUserAPI({ email, password });
    window.__ADD_EVENT__('General - User Login', { user: userResp.user });
    return dispatch({
      type: LOGIN_USER_SUCCESS,
      user: userResp.user,
      tokens: {
        access_token: userResp.access_token,
        refresh_token: userResp.refresh_token,
      },
    });
  } catch (error) {
    return dispatch({
      type: LOGIN_USER_FAILURE,
      error,
    });
  }
};

export const registerUser = ({ email, password }) => async (dispatch, getState) => {
  try {
    const userResp = await registerUserAPI({ email, password1: password, password2: password });
    return dispatch({
      type: REGISTER_USER_SUCCESS,
      user: userResp.user,
      tokens: {
        access_token: userResp.access_token,
        refresh_token: userResp.refresh_token,
      },
    });
  } catch (error) {
    return dispatch({
      type: REGISTER_USER_FAILURE,
      error,
    });
  }
};

export const logoutUser = (username, password) => async (dispatch, getState) => {
  window.__ADD_EVENT__('General - User Logout', { username, password });
  return dispatch({
    type: LOGOUT_USER_SUCCESS,
  });
};

export const connectZoomAccount = (code) => async (dispatch, getState) => {
  try {
    await connectZoomAccountAPI(code);
    dispatch(syncUser()); // For now we can use this to keep things simple with a single sync call to get the zoom_connected=true statement
    removeUrlParameter('code');
    window.__ADD_EVENT__('Account - Connect Zoom Account');
    return dispatch({
      type: CONNECT_ZOOM_ACCOUNT_SUCCESS,
    });
  } catch (error) {
    console.error(error);
    return dispatch({
      type: CONNECT_ZOOM_ACCOUNT_FAILURE,
      error,
    });
  }
};

export const connectHubspotAccount = (code) => async (dispatch, getState) => {
  try {
    await connectHubspotAccountAPI(code);
    removeUrlParameter('code');
    dispatch(syncUser()); // For now we can use this to keep things simple with a single sync call to get the hubspot_connected=true statement
    window.__ADD_EVENT__('Account - Connect Hubspot Account');
    return dispatch({
      type: CONNECT_HUBSPOT_ACCOUNT_SUCCESS,
    });
  } catch (error) {
    console.error(error);
    return dispatch({
      type: CONNECT_HUBSPOT_ACCOUNT_FAILURE,
      error,
    });
  }
};
